module.exports = __webpack_public_path__ + "static/media/SF UI Display Semibold.b86d7f79.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF UI Display Semibold.eot
// module id = 71
// module chunks = 0